module.exports = __webpack_public_path__ + "img/loanapproval.443cbb89.svg";